import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Home } from "@/components/Home";
import { Article } from "@/pages/Article";
import { RecruitmentPage } from "@/pages/RecruitmentPage";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/recruitment" element={<RecruitmentPage />} />
        <Route path="/insights/:slug" element={<Article />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
